import axios from "axios"
import { useState } from "react"
import { get_property_reports_traffic } from "../../api/api"
import queryString from 'query-string'

const FilterReportSecoundCategories = ({ queries, setData, active, mode }) => {

    const [isLoading, setIsLoading] = useState(false)

    const handleOnClick = async (e) => {
        if (active?.primarySubjectCategoryId) {
            try {
                setData({})
                setIsLoading(true)
                const res = await axios.get(get_property_reports_traffic(queryString.stringify(queries), 2, active))
                setData({ type: 4, data: { secondarySubjectCategoryId: res.data }, mode: mode })
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false)
            }
        }
    }


    return ((active?.primarySubjectCategoryId && active?.primarySubjectCategoryId || active?.secondarySubjectCategoryId) &&
        <>
            <button
                disabled={isLoading}
                className={`moreFiltersButton ${active?.secondarySubjectCategoryId ? 'active' : ''} ${mode ? 'chartModeBtn' : ''}`}
                type="button"
                onClick={handleOnClick}>{isLoading ? '...' : 'دسته بندی ثانویه'}
                {!isLoading && active?.secondarySubjectCategoryId ? ': ' + active.secondarySubjectCategoryId?.name : ''}
            </button>
        </>
    );
}

export default FilterReportSecoundCategories;